export default __webpack_public_path__ + "static/media/video.aedf485d.mp4";